export class RiskyPregnancyCertificateByCompany {
  [company: string]: RiskyPregnancyCertificate[];
}

export class RiskyPregnancyCertificate {
  companyCode!: string;
  employeeNumber!: string;
  companyName?: string;
  certType?: string;
  startDate!: string;
}
